import script from "./universal_styles.vue?vue&type=script&lang=js"
export * from "./universal_styles.vue?vue&type=script&lang=js"

import "./universal_styles.vue?vue&type=style&index=0&id=2fadb04b&lang=scss"

const __exports__ = script;

export default __exports__